module.exports = __webpack_public_path__ + "static/img/11e.e0a85e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11e.jpg
// module id = Xq7k
// module chunks = 0